import { isNull, isUndefined } from "util";

export const DecimalAsComma = (value : any) : string =>
{
	if (isNaN(value) || isNull(value) || isUndefined(value))
		return '';

	let numericValue = parseFloat(value);
	let stringValue = numericValue.toFixed(2);

	stringValue = stringValue.replace('.', ',');

	return stringValue;
}

/**
 * Formata um valor numérico para exibição em campos de input com 2 casas decimais
 * Retorna o valor formatado com ponto como separador decimal (padrão para inputs type="number")
 * Padrão Autorizações CIBIO: sempre 2 casas decimais
 */
export const FormatDecimalForInput = (value : any) : string =>
{
	if (isNaN(value) || isNull(value) || isUndefined(value) || value === '')
		return '';

	let numericValue = parseFloat(value);
	
	// Sempre retorna com 2 casas decimais (padrão Autorizações CIBIO)
	return numericValue.toFixed(2);
}

/**
 * Formata um valor numérico para exibição com 2 casas decimais (com vírgula para exibição)
 */
export const FormatDecimalForDisplay = (value : any) : string =>
{
	if (isNaN(value) || isNull(value) || isUndefined(value) || value === '')
		return '';

	let numericValue = parseFloat(value);
	let stringValue = numericValue.toFixed(2);

	stringValue = stringValue.replace('.', ',');

	return stringValue;
}